import { forwardRef } from 'react';

import type ITableRow from './interfaces/ITableRow';

const TableRow = forwardRef<HTMLTableRowElement, ITableRow>(({ children, className, onClick }, ref) => (
  <tr className={className} onClick={onClick} ref={ref}>
    {children}
  </tr>
));

export default TableRow;
